"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "ApplicationVersion", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.ApplicationVersion;
  }
}), Object.defineProperty(exports, "ApplicationVersionDataType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.ApplicationVersionDataType;
  }
}), Object.defineProperty(exports, "BooleanVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.BooleanVariableType;
  }
}), Object.defineProperty(exports, "Browser", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.Browser;
  }
}), Object.defineProperty(exports, "BrowserType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.BrowserType;
  }
}), Object.defineProperty(exports, "ConfigurationDataType", {
  enumerable: !0,
  get: function get() {
    return _clientConfiguration.ConfigurationDataType;
  }
}), Object.defineProperty(exports, "ConfigurationUpdateEventDataType", {
  enumerable: !0,
  get: function get() {
    return _eventManager.ConfigurationUpdateEventDataType;
  }
}), Object.defineProperty(exports, "Conversion", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.Conversion;
  }
}), Object.defineProperty(exports, "ConversionParametersType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.ConversionParametersType;
  }
}), Object.defineProperty(exports, "Cookie", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.Cookie;
  }
}), Object.defineProperty(exports, "CookieType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.CookieType;
  }
}), Object.defineProperty(exports, "CustomData", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.CustomData;
  }
}), Object.defineProperty(exports, "Device", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.Device;
  }
}), Object.defineProperty(exports, "DeviceType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.DeviceType;
  }
}), Object.defineProperty(exports, "Environment", {
  enumerable: !0,
  get: function get() {
    return _types.Environment;
  }
}), Object.defineProperty(exports, "Err", {
  enumerable: !0,
  get: function get() {
    return _tsRes.Err;
  }
}), Object.defineProperty(exports, "EvaluationEventDataType", {
  enumerable: !0,
  get: function get() {
    return _eventManager.EvaluationEventDataType;
  }
}), Object.defineProperty(exports, "EventCallbackType", {
  enumerable: !0,
  get: function get() {
    return _eventManager.EventCallbackType;
  }
}), Object.defineProperty(exports, "EventDataType", {
  enumerable: !0,
  get: function get() {
    return _eventManager.EventDataType;
  }
}), Object.defineProperty(exports, "EventSourceOpenParametersType", {
  enumerable: !0,
  get: function get() {
    return _eventSource.EventSourceOpenParametersType;
  }
}), Object.defineProperty(exports, "EventType", {
  enumerable: !0,
  get: function get() {
    return _eventManager.EventType;
  }
}), Object.defineProperty(exports, "ExternalPackageInfoType", {
  enumerable: !0,
  get: function get() {
    return _types.ExternalPackageInfoType;
  }
}), Object.defineProperty(exports, "FeatureFlagType", {
  enumerable: !0,
  get: function get() {
    return _types.FeatureFlagType;
  }
}), Object.defineProperty(exports, "FeatureFlagVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.FeatureFlagVariableType;
  }
}), Object.defineProperty(exports, "FeatureFlagVariationsType", {
  enumerable: !0,
  get: function get() {
    return _storage.FeatureFlagVariationsType;
  }
}), Object.defineProperty(exports, "FeatureVariableResultType", {
  enumerable: !0,
  get: function get() {
    return _types.FeatureVariableResultType;
  }
}), Object.defineProperty(exports, "GeolocationData", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.GeolocationData;
  }
}), Object.defineProperty(exports, "GeolocationInfoType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.GeolocationInfoType;
  }
}), Object.defineProperty(exports, "GetFeatureFlagVariableParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.GetFeatureFlagVariableParamsType;
  }
}), Object.defineProperty(exports, "GetVariationParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.GetVariationParamsType;
  }
}), Object.defineProperty(exports, "GetVariationsParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.GetVariationsParamsType;
  }
}), Object.defineProperty(exports, "GetVisitorWarehouseAudienceParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.GetVisitorWarehouseAudienceParamsType;
  }
}), Object.defineProperty(exports, "Header", {
  enumerable: !0,
  get: function get() {
    return _requester.Header;
  }
}), Object.defineProperty(exports, "HeadersType", {
  enumerable: !0,
  get: function get() {
    return _requester.HeadersType;
  }
}), Object.defineProperty(exports, "HttpMethod", {
  enumerable: !0,
  get: function get() {
    return _requester.HttpMethod;
  }
}), Object.defineProperty(exports, "IExternalEventSource", {
  enumerable: !0,
  get: function get() {
    return _eventSource.IExternalEventSource;
  }
}), Object.defineProperty(exports, "IExternalLogger", {
  enumerable: !0,
  get: function get() {
    return _logging.IExternalLogger;
  }
}), Object.defineProperty(exports, "IExternalPRNG", {
  enumerable: !0,
  get: function get() {
    return _utilities.IExternalPRNG;
  }
}), Object.defineProperty(exports, "IExternalRequester", {
  enumerable: !0,
  get: function get() {
    return _requester.IExternalRequester;
  }
}), Object.defineProperty(exports, "IExternalStorage", {
  enumerable: !0,
  get: function get() {
    return _storage.IExternalStorage;
  }
}), Object.defineProperty(exports, "IKameleoonCore", {
  enumerable: !0,
  get: function get() {
    return _kameleoonClientInterface.IKameleoonClient;
  }
}), Object.defineProperty(exports, "IVisitorCodeManager", {
  enumerable: !0,
  get: function get() {
    return _visitorCodeManager.IVisitorCodeManager;
  }
}), Object.defineProperty(exports, "InternalSDKConfigurationType", {
  enumerable: !0,
  get: function get() {
    return _types.InternalSDKConfigurationType;
  }
}), Object.defineProperty(exports, "InternalsType", {
  enumerable: !0,
  get: function get() {
    return _types.InternalsType;
  }
}), Object.defineProperty(exports, "IsFeatureFlagActiveParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.IsFeatureFlagActiveParamsType;
  }
}), Object.defineProperty(exports, "JSONType", {
  enumerable: !0,
  get: function get() {
    return _clientConfiguration.JSONType;
  }
}), Object.defineProperty(exports, "JSONVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.JSONVariableType;
  }
}), Object.defineProperty(exports, "KameleoonCore", {
  enumerable: !0,
  get: function get() {
    return _kameleoonClient.KameleoonClient;
  }
}), Object.defineProperty(exports, "KameleoonData", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.KameleoonData;
  }
}), Object.defineProperty(exports, "KameleoonDataType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.KameleoonDataType;
  }
}), Object.defineProperty(exports, "KameleoonError", {
  enumerable: !0,
  get: function get() {
    return _kameleoonError.KameleoonError;
  }
}), Object.defineProperty(exports, "KameleoonException", {
  enumerable: !0,
  get: function get() {
    return _kameleoonError.KameleoonException;
  }
}), Object.defineProperty(exports, "KameleoonLogger", {
  enumerable: !0,
  get: function get() {
    return _logging.KameleoonLogger;
  }
}), Object.defineProperty(exports, "KameleoonResponseType", {
  enumerable: !0,
  get: function get() {
    return _requester.KameleoonResponseType;
  }
}), Object.defineProperty(exports, "KameleoonStorageKey", {
  enumerable: !0,
  get: function get() {
    return _storage.KameleoonStorageKey;
  }
}), Object.defineProperty(exports, "KameleoonUtils", {
  enumerable: !0,
  get: function get() {
    return _kameleoonUtils.KameleoonUtils;
  }
}), Object.defineProperty(exports, "KameleoonVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.KameleoonVariableType;
  }
}), Object.defineProperty(exports, "KameleoonVariationType", {
  enumerable: !0,
  get: function get() {
    return _types.KameleoonVariationType;
  }
}), Object.defineProperty(exports, "LogLevel", {
  enumerable: !0,
  get: function get() {
    return _logging.LogLevel;
  }
}), Object.defineProperty(exports, "Milliseconds", {
  enumerable: !0,
  get: function get() {
    return _types.Milliseconds;
  }
}), Object.defineProperty(exports, "NUMBER_OF_RETRIES", {
  enumerable: !0,
  get: function get() {
    return _requester.NUMBER_OF_RETRIES;
  }
}), Object.defineProperty(exports, "NumberVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.NumberVariableType;
  }
}), Object.defineProperty(exports, "Ok", {
  enumerable: !0,
  get: function get() {
    return _tsRes.Ok;
  }
}), Object.defineProperty(exports, "OperatingSystem", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.OperatingSystem;
  }
}), Object.defineProperty(exports, "OperatingSystemType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.OperatingSystemType;
  }
}), Object.defineProperty(exports, "PageView", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.PageView;
  }
}), Object.defineProperty(exports, "PageViewParametersType", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.PageViewParametersType;
  }
}), Object.defineProperty(exports, "Parser", {
  enumerable: !0,
  get: function get() {
    return _parser.Parser;
  }
}), Object.defineProperty(exports, "RemoteVisitorDataParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.RemoteVisitorDataParamsType;
  }
}), Object.defineProperty(exports, "RequestParametersType", {
  enumerable: !0,
  get: function get() {
    return _requester.RequestParametersType;
  }
}), Object.defineProperty(exports, "RequestType", {
  enumerable: !0,
  get: function get() {
    return _requester.RequestType;
  }
}), Object.defineProperty(exports, "Result", {
  enumerable: !0,
  get: function get() {
    return _tsRes.Result;
  }
}), Object.defineProperty(exports, "RetryCountType", {
  enumerable: !0,
  get: function get() {
    return _requester.RetryCountType;
  }
}), Object.defineProperty(exports, "SDKConfigurationType", {
  enumerable: !0,
  get: function get() {
    return _types.SDKConfigurationType;
  }
}), Object.defineProperty(exports, "SDKCoreParameters", {
  enumerable: !0,
  get: function get() {
    return _types.SDKCoreParameters;
  }
}), Object.defineProperty(exports, "SdkLanguageType", {
  enumerable: !0,
  get: function get() {
    return _constants.SdkLanguageType;
  }
}), Object.defineProperty(exports, "SendRequestParametersType", {
  enumerable: !0,
  get: function get() {
    return _requester.SendRequestParametersType;
  }
}), Object.defineProperty(exports, "SetDataCallbackParametersType", {
  enumerable: !0,
  get: function get() {
    return _types.SetDataCallbackParametersType;
  }
}), Object.defineProperty(exports, "SetForcedVariationParametersType", {
  enumerable: !0,
  get: function get() {
    return _types.SetForcedVariationParametersType;
  }
}), Object.defineProperty(exports, "SimulateRequestDataType", {
  enumerable: !0,
  get: function get() {
    return _types.SimulateRequestDataType;
  }
}), Object.defineProperty(exports, "StorageDataType", {
  enumerable: !0,
  get: function get() {
    return _storage.StorageDataType;
  }
}), Object.defineProperty(exports, "StringVariableType", {
  enumerable: !0,
  get: function get() {
    return _types.StringVariableType;
  }
}), Object.defineProperty(exports, "TrackConversionParamsType", {
  enumerable: !0,
  get: function get() {
    return _types.TrackConversionParamsType;
  }
}), Object.defineProperty(exports, "TrackingStatus", {
  enumerable: !0,
  get: function get() {
    return _types.TrackingStatus;
  }
}), Object.defineProperty(exports, "UniqueIdentifier", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.UniqueIdentifier;
  }
}), Object.defineProperty(exports, "UserAgent", {
  enumerable: !0,
  get: function get() {
    return _kameleoonData.UserAgent;
  }
}), Object.defineProperty(exports, "VISITOR_CODE_LENGTH", {
  enumerable: !0,
  get: function get() {
    return _visitorCodeManager.VISITOR_CODE_LENGTH;
  }
}), Object.defineProperty(exports, "Validator", {
  enumerable: !0,
  get: function get() {
    return _utilities.Validator;
  }
}), Object.defineProperty(exports, "VariableType", {
  enumerable: !0,
  get: function get() {
    return _types.VariableType;
  }
}), Object.defineProperty(exports, "VariationType", {
  enumerable: !0,
  get: function get() {
    return _types.VariationType;
  }
}), Object.defineProperty(exports, "VisitorCodeManager", {
  enumerable: !0,
  get: function get() {
    return _visitorCodeManager.VisitorCodeManager;
  }
}), Object.defineProperty(exports, "VisitorDataFiltersType", {
  enumerable: !0,
  get: function get() {
    return _utilities.VisitorDataFiltersType;
  }
});
var _tsRes = require("ts-res"),
  _kameleoonClient = require("./kameleoonClient"),
  _kameleoonUtils = require("./kameleoonUtils"),
  _kameleoonClientInterface = require("./kameleoonClientInterface"),
  _kameleoonError = require("./kameleoonError"),
  _utilities = require("./utilities"),
  _storage = require("./storage"),
  _eventManager = require("./eventManager"),
  _visitorCodeManager = require("./visitorCodeManager"),
  _logging = require("./logging"),
  _parser = require("./utilities/parser"),
  _constants = require("./constants"),
  _clientConfiguration = require("./clientConfiguration"),
  _types = require("./types"),
  _kameleoonData = require("./kameleoonData"),
  _eventSource = require("./eventSource"),
  _requester = require("./requester");